<template>
    <div>        
        <el-row :gutter="10">
            <el-col :xs="24" :sm="4" :md="4">
                <label>Período Letivo</label>
                <el-select @change="changeFiltros" v-model="filtro['periodo_letivo_id']">
                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                </el-select>                    
            </el-col>
            <el-col :xs="24" :sm="6" :md="6">
                <label>Contexto</label>
                <el-select clearable @change="changeFiltros" v-model="filtro['contexto']">
                    <el-option key="frequencia" label="FREQUÊNCIA" value="frequencia"></el-option>
                    <el-option key="nota" label="NOTA" value="nota"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="14" :md="14">
                <label>Aluno</label>
                <el-select @change="changeFiltros" v-model="filtro['aluno_id']" placeholder="pesquisar..." filterable clearable remote :remote-method="getAlunoByFilter" :loading="loadingAluno">
                    <el-option v-for="item in alunos" :key="item.id" :label="item.nome" :value="item.id"> </el-option>
                </el-select>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="u-mt-10 u-mb-10">
            <el-col :xs="24" :sm="12" :md="12" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6">
                <label>Filtrar por Instituição</label>
                <el-select filterable clearable @change="changeInstituicao" v-model="filtro.instituicao_id">
                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="($store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6) ? 12 : 24" :md="($store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6) ? 12 : 24">
                <label>Turma</label>
                <el-select v-model="filtro['turma_id']" @change="changeFiltros" clearable>
                    <el-option-group
                        v-for="(grupo, i) in turmas"
                        :key="i"
                        label="">
                    <el-option
                        v-for="turma in grupo"
                        :key="turma.id"
                        :label="`${turma.curso.nome} ${turma.nome}`"
                        :value="turma.id">
                    </el-option>
                    </el-option-group>
                </el-select>
            </el-col>           
        </el-row>
        <el-row :gutter="10" class="u-mt-10 u-mb-10">
            <el-col :xs="24" :sm="24" :md="24">
                <label>Filtrar Ocorrência</label>
                <el-input v-model="filtro['ocorrencia']" placeholder="Pesquisar log..." @keyup.native.enter="changeFiltros"></el-input>
            </el-col>            
        </el-row>
        <div class="container-table">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 150px;">Data da Ocorrência</th>
                        <th>Ocorrência</th>
                        <th>Turma</th>
                        <th>Aluno</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ (item.created_at) ? $moment(item.created_at).format('DD/MM/YYYY HH:mm:ss') : '' }}</td>
                        <td>{{ (item.usuario_nome ? item.usuario_nome : '') + ' ' + item.ocorrencia }}</td>
                        <td>{{ item.turma_nome ? item.turma_nome : '-' }}</td>
                        <td>{{ item.aluno_nome ? item.aluno_nome : '-' }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                            <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>
<script>

export default {
    data: () => ({
        loadingAluno: false,
        alunos: [],
        statusList: false,
        turmas: [],
        filtro: {
            periodo_letivo_id: '',
            ocorrencia: '',
            instituicao_id: '',
            aluno_id: '',
            turma_id: '',
            contexto: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: [ ],
        usuarios: []
    }),
    mounted () {

        this.filtro.periodo_letivo_id = this.$store.state.config.periodo.id;

        if(this.$store.state.user.tipo != 4 && this.$store.state.user.tipo != 5 && this.$store.state.user.tipo != 6 && this.$store.state.config.instituicao){ 
            
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id;
        }

        this.loadingLogs()
        this.getTurmas()
      
    },
    methods: {

        getTurmas(){

            let periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica;

            if(!this.filtro.instituicao_id || !periodo_letivo_id){
                this.filtro.turma_id = [];
                return false;
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/` + this.filtro.instituicao_id + '/' + periodo_letivo_id, this.$store.getters.getHeaderAuth).then(response => {

                this.turmas = response.data;

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

        },
        getAlunoByFilter(query){

            if (query.length < 4){

                this.alunos = [];
                return false;
            }

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/searchByNome`, {query: query}, this.$store.getters.getHeaderAuth).then(response => {

                this.alunos = JSON.parse(JSON.stringify(response.data));

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        changeInstituicao(){

            this.getTurmas();
            this.loadingLogs();
        },
        changeFiltros(){

            this.paginate.page = 1;
            this.loadingLogs();
        },
        loadingLogs(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/diario/log/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        deleteLog(id){

            this.$msgbox.confirm('Tem certeza que deseja excluir este log?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }).then(() => {

                window.eventBus.$emit('loading', true);
                    
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/log/delete/` + id, this.$store.getters.getHeaderAuth).then(response => {
                            
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.loadingLogs();

                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

            }).catch(()=>{});

        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingLogs();
        }
    },
    components:{  }
}
</script>